var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-180 23.5 23.5)",
    stroke: "#535353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.763 7.2a.36.36 0 01.254.105l4.44 4.44a.36.36 0 010 .51l-4.44 4.44a.36.36 0 11-.51-.51L14.694 12l-4.185-4.185a.36.36 0 01.255-.615z",
    fill: "#000"
  })));
}

export default SvgRightChevron;